import { HelpVideoChildComponent } from '../helpVideoChildComponent';

const CandidateCommunication = () => {
  const topicList = [
    { id: '832616718', label: 'How to use Bulk Email Templates' },
    { id: '832618758', label: 'How to use submission email Templates' },
  ];
  return <HelpVideoChildComponent isFromSettings={true} topicArrayList={topicList} />;
};

export default CandidateCommunication;
